import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Onebet } from '../../models/onebet.model';

@Injectable({
  providedIn: 'root'
})
export class OnebetService {

  constructor(
    private afs: AngularFirestore,   // Inject Firestore service
  ) { }


  getSignals() {
    return this.afs.collection('signals/onebet/items', ref => ref
      //.limit(20)
      .orderBy('cdate', 'desc')).get();
  }

  createSignal(signal: any) {
    return this.afs.collection('signals/onebet/items').add({
      bet: signal.bet,
      momios: signal.momios,
      category: signal.category,
      event: signal.event,
      title: signal.title,
      status: signal.status,
      dateOfEvent: signal.dateOfEvent,
      cdate: signal.cdate
    }
    );
  }

  updateSignal(signal: Onebet) {
    return this.afs.collection('signals/onebet/items').doc(signal.id)
      .set({ bet: signal.bet, momios: signal.momios, status: signal.status }, { merge: true });
  }

  deleteSignal(signal: any) {
    return this.afs.collection('signals/onebet/items').doc(signal).delete();
  }
}
